import { createFcmExperimentsContext } from 'src/app/shared/contexts/experiment';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmExperimentsContext: DecisionMakerResponsePageFcmExperimentsContext,
	FcmExperimentsProvider: DecisionMakerResponsePageFcmExperimentsContextProvider,
	useFcmExperiments: useDecisionMakerResponsePageFcmExperiments,
	useAsyncFcmExperiments: useAsyncDecisionMakerResponsePageFcmExperiments,
	prefetchFcmExperiments: prefetchDecisionMakerResponsePageFcmExperiments,
} = createFcmExperimentsContext({
	name: 'DecisionMakerResponsePageFcmExperimentsContext',
	dataProperty: 'pageFcmExperiments',
	configs: {},
	prefetch: true,
});

export type DecisionMakerResponsePageFcmExperimentsState = ReturnType<
	typeof useAsyncDecisionMakerResponsePageFcmExperiments
>;
export type DecisionMakerResponsePageFcmExperiments = LoadedStateData<DecisionMakerResponsePageFcmExperimentsState>;
